/* Size the Shopify iframe to the visible page; do not change contact handling. */
(function () {
  'use strict';
  if (window.S10ConfiguratorLayout) return;
  window.S10ConfiguratorLayout = true;

  var states = new Map();
  var scheduled = false;
  var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  function update() {
    scheduled = false;
    var viewportHeight = document.documentElement.clientHeight || window.innerHeight;
    var badge = document.querySelector('#shop-hcaptcha-badge-container');
    var badgeRect = badge && badge.getBoundingClientRect();
    var bottomClearance = badgeRect && badgeRect.height && badgeRect.top < viewportHeight
      ? Math.max(12, viewportHeight - badgeRect.top + 8) : 12;
    var header = document.querySelector('m-header');
    var headerRect = header && header.getBoundingClientRect();
    var overflow = 0;
    if (headerRect && headerRect.height) {
      // This theme's desktop menu can wrap to two rows while its outer header
      // still reserves one row. Keep the iframe below the actual visible menu.
      header.querySelectorAll('header').forEach(function (element) {
        var rect = element.getBoundingClientRect();
        if (rect.width && rect.height) overflow = Math.max(overflow, rect.bottom - headerRect.bottom);
      });
    }

    document.querySelectorAll('[data-configurator]').forEach(function (section) {
      var frame = section.querySelector('#s10-configurator-frame');
      var wrapper = section.querySelector('.s10-configurator__frame');
      if (!frame || !wrapper) return;
      var state = states.get(frame);
      if (!state) {
        state = { gap: 0, padding: parseFloat(getComputedStyle(wrapper).paddingTop) || 0 };
        states.set(frame, state);
        frame.addEventListener('load', schedule);
      }
      var naturalTop = frame.getBoundingClientRect().top + window.scrollY - state.gap;
      var flowHeaderBottom = headerRect ? headerRect.bottom + window.scrollY : 0;
      var gap = Math.max(0, overflow - Math.max(0, naturalTop - flowHeaderBottom));
      if (gap !== state.gap) {
        wrapper.style.paddingTop = (state.padding + gap) + 'px';
        state.gap = gap;
      }
      var top = naturalTop + gap;
      // Use document position, not the changing scroll position: scrolling the
      // page must not repeatedly grow the iframe or move the footer away.
      var height = Math.max(240, Math.floor(viewportHeight - Math.max(0, top) - bottomClearance));
      frame.style.height = height + 'px';
      frame.dataset.viewportFit = 'true';
    });
  }

  function observeHeader() {
    if (observer) {
      observer.disconnect();
      document.querySelectorAll('m-header, m-header header, m-announcement-bar, #shop-hcaptcha-badge-container').forEach(function (element) {
        observer.observe(element);
      });
    }
    schedule();
  }
  // The badge is injected asynchronously by Shopify after page load.
  var additions = new MutationObserver(function () { schedule(); });
  additions.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', schedule, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', observeHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeHeader);
  else observeHeader();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
})();
